import { Component, OnInit } from '@angular/core';
import { Item } from '../../../core/components/listbox/listbox.component';
import { DataTaskService } from '../../../core/services/data-task.service';
import { FormButton } from '../../../core/components/form-field-button/form-field-button.component';

@Component({
  selector: 'tt-find-person',
  templateUrl: './find-person.component.html',
  styleUrls: ['./find-person.component.css']
})
export class FindPersonComponent implements OnInit {
    public setting?: Setting;

    public itemsListFindPersons: Item[] = [];

    public searchTextButtons: FormButton[] = [
        { id: 'erase', type: 'danger', icon: 'fa fa-solid fa-eraser', onClick: () => this.clear('searchtext') },
        { id: 'search', type: 'primary', icon: 'fas fa-search', onClick: () => this.loadFindPersons() }
    ];

    constructor(private datatask: DataTaskService) {

    }

    private async loadSetting() {
        this.setting = (await this.datatask.Post(1124))[0];
    }

    private async loadFindPersons() {
        if (!!this.setting) {
            this.itemsListFindPersons = await this.datatask.Post(1125, this.setting);
        }
    }

    private clear(id: string) {
        switch (id) {
            case 'searchtext':
                if (!!this.setting) {
                    this.setting.searchtext = '';
                    this.itemsListFindPersons = [];
                }
                break;
            default:
                break;
        }
    }

    public onBlur(id: string) {
        switch (id) {
            case 'searchtext':
                if (!!this.setting) {
                    if (this.setting?.searchtext !== '') this.loadFindPersons();
                }
                break;
            default:
                break;
        }
    }

    public onChanged(_: string, id: keyof Setting) {
        switch (id) {
            case 'searchtext':
                if (this.setting?.searchtext === '') this.clear('searchtext');
                break;
            default:
                break;
        }
    }

    public searchItems() {
        this.loadFindPersons();
    }

    private async init() {
        await this.loadSetting();
        if (this.setting?.searchtext !== '') this.loadFindPersons();
    }

    ngOnInit() {
        this.init();
    }
}

interface Setting {
    searchtext: string;
}
